import { useMutation } from "@apollo/client";
import type {
  CreateOrganizationInviteSecurePayload,
  CreateOrganizationInviteSecureInput,
} from "@casey/db-types";
import { CREATE_ORGANIZATION_INVITE } from "../gql";

export function useCreateOrganizationInvite() {
  return useMutation<
    { createOrganizationInviteSecure: CreateOrganizationInviteSecurePayload },
    CreateOrganizationInviteSecureInput
  >(CREATE_ORGANIZATION_INVITE);
}
